export default "__VITE_ASSET__d254975a__"